import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { api, errText } from "../lib/api";
import { useStore } from "../context/Store";
import { CityView, OccasionView, ComboView, CorridorView, FloristView, GuideView } from "./Landing";
import { t } from "../i18n";
import NotFound from "../components/NotFound";
import Seo from "../components/Seo";

export default function Resolver() {
  const { locale = "en" } = useParams();
  const { currency } = useStore();
  const location = useLocation();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [notFound, setNotFound] = useState(false);

  const path = decodeURIComponent(location.pathname.split("/").slice(2).join("/"));

  useEffect(() => {
    setData(null);
    setError("");
    setNotFound(false);
    let cancelled = false;
    // Retry transient failures so crawlers (Google, GPTBot…) never see a noindex 404 for a real page.
    const load = (attempt) => api
      .get("/resolve", { params: { path, locale, currency } })
      .then((r) => { if (!cancelled) setData(r.data); })
      .catch((e) => {
        if (cancelled) return;
        if (e?.response?.status === 404) { setNotFound(true); setError(errText(e)); return; }
        if (attempt < 3) { setTimeout(() => load(attempt + 1), 800 * (attempt + 1)); return; }
        setError(errText(e));
      });
    load(0);
    window.scrollTo(0, 0);
    return () => { cancelled = true; };
  }, [path, locale, currency]);

  if (notFound) return <NotFound message={error} />;
  if (error) return <div className="max-w-content mx-auto px-6 py-24 text-muted" data-testid="resolver-error">{error}</div>;
  if (!data) return <div className="max-w-content mx-auto px-6 py-24 text-muted">{t(locale, "loading")}…</div>;

  switch (data.type) {
    case "city":
      return <CityView data={data} />;
    case "city_same_day":
      return <CityView data={data} sameDay />;
    case "occasion":
      return <OccasionView data={data} />;
    case "city_occasion":
      return <ComboView data={data} />;
    case "corridor":
      return <CorridorView data={data} />;
    case "florist":
      return <FloristView data={data} />;
    case "guide":
      return <GuideView data={data} />;
    default:
      return <NotFound />;
  }
}
